import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as d, normalizeClass as l, createElementVNode as n } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconSkip15Sec",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, o = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.225 2.007a4 4 0 1 0 3.753 4.415.5.5 0 0 1 .995.105 5 5 0 1 1-1.667-4.278l.004.004.69.62v-.399a.5.5 0 0 1 1 0v1.5a.5.5 0 0 1-.5.5h-.023a.28.28 0 0 1-.004 0H9a.5.5 0 1 1 0-1h.172l-.53-.476a4 4 0 0 0-2.417-.991ZM5.977 4.5a.5.5 0 0 1 .5-.5h1.308a.5.5 0 0 1 0 1h-.808v.272c.169-.014.357 0 .548.073.398.149.593.457.68.72.08.242.08.472.08.56v.008c0 .167-.053.421-.177.659-.128.245-.369.54-.78.645-.35.09-.65.037-.893-.097a1.568 1.568 0 0 1-.417-.353l-.013-.014a.5.5 0 0 1 .749-.663c.081.092.12.13.163.154a.133.133 0 0 0 .05.016.305.305 0 0 0 .113-.011c.043-.012.093-.046.142-.14a.647.647 0 0 0 .052-.138c.01-.04.011-.061.011-.061v.003a.816.816 0 0 0-.029-.253.205.205 0 0 0-.035-.068.107.107 0 0 0-.048-.032.33.33 0 0 0-.201.006.652.652 0 0 0-.194.09.5.5 0 0 1-.8-.4V4.5Zm-.785-.461A.5.5 0 0 1 5.5 4.5v3a.5.5 0 0 1-1 0V5.708l-.146.146a.5.5 0 1 1-.707-.707l1-1a.5.5 0 0 1 .545-.108Z",
  fill: "currentColor"
}, null, -1), m = [
  _
];
function u(e, h, i, p, f, a) {
  return d(), r("svg", {
    "aria-label": i.ariaLabel,
    class: l([a.iconSizeClass, "d-icon d-icon--skip-15-sec"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Skip 15 Sec",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, m, 10, o);
}
const g = /* @__PURE__ */ s(c, [["render", u]]);
export {
  g as default
};
//# sourceMappingURL=skip-15-sec.js.map
